var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("dsf-exam-layout", {
    attrs: { "exam-loading": _vm.examLoading },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm.examInfoData
              ? _c("h3", { staticStyle: { "text-align": "center" } }, [
                  _vm._v(" " + _vm._s(_vm.examInfoData.manageName) + " "),
                ])
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "left",
        fn: function () {
          return [
            _c("p", { staticClass: "sub-title list bg pd-10" }, [
              _vm._v("答题卡"),
            ]),
            _c(
              "div",
              { staticClass: "card-list" },
              [
                _vm._l(_vm.examInfoData.items, function (data, index) {
                  return [
                    _c(
                      "p",
                      {
                        key: "sub_" + index + data.examPaperId,
                        staticClass: "sub-title list pd-10",
                      },
                      [
                        _vm._v(" " + _vm._s(data.name) + " "),
                        _c("span", { staticClass: "sub" }, [
                          _vm._v(
                            " （共" +
                              _vm._s(data.totalNum) +
                              "题，合计" +
                              _vm._s(data.totalScore) +
                              "分） "
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        key: "list_" + index + data.examPaperId,
                        staticClass: "question-list",
                      },
                      [
                        _vm._l(data.questions, function (q, i) {
                          return [
                            data.questionsItems.value != "group"
                              ? _c(
                                  "div",
                                  {
                                    key: "item_" + q.examQuestionsId,
                                    class: [
                                      "item",
                                      q.resScore ? "answered" : "",
                                      q.marked ? "marked" : "",
                                    ],
                                    on: {
                                      click: function ($event) {
                                        return _vm.toScroll(q.examQuestionsId)
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(++i) + " ")]
                                )
                              : _vm._l(q.children, function (childValue) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        key:
                                          "group_" + childValue.examQuestionsId,
                                        class: [
                                          "item",
                                          childValue.resScore ? "answered" : "",
                                          childValue.marked ? "marked" : "",
                                        ],
                                        on: {
                                          click: function ($event) {
                                            return _vm.toScroll(
                                              childValue.examQuestionsId,
                                              childValue.groupIndex - 1
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(childValue.groupIndex) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                }),
                          ]
                        }),
                      ],
                      2
                    ),
                  ]
                }),
              ],
              2
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "main",
        fn: function () {
          return [
            _vm._l(_vm.examInfoData.items, function (data, index) {
              return [
                _c(
                  "p",
                  {
                    key: "title_" + data.examPaperItemsId,
                    staticClass: "sub-title list bg pd-20",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.dsf.math.toChinesNum(++index) + "、" + data.name
                        ) +
                        " "
                    ),
                    data.score && data.totalScore
                      ? _c("span", { staticClass: "sub" }, [
                          _vm._v(
                            " （共" +
                              _vm._s(data.questions.length) +
                              "题，合计" +
                              _vm._s(data.totalScore) +
                              "分） "
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
                _c(
                  "div",
                  {
                    key: data.examPaperItemsId + index,
                    staticClass: "exam-content",
                  },
                  _vm._l(data.questions, function (subjects, examIndex) {
                    return _c(
                      "div",
                      {
                        key: examIndex + subjects.examQuestionsId,
                        staticClass: "question",
                      },
                      [
                        _c(
                          "div",
                          {
                            ref: "question" + subjects.examQuestionsId,
                            refInFor: true,
                            staticClass: "left",
                          },
                          [
                            _c("dsf-exam-item-box", {
                              attrs: {
                                subjects: subjects,
                                "exam-index": examIndex,
                                readOnly: true,
                              },
                            }),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "right" }, [
                          _c(
                            "div",
                            { staticClass: "count" },
                            [
                              _c("p", [
                                _vm._v(
                                  "满分: " + _vm._s(subjects.score) + "分"
                                ),
                              ]),
                              _c(
                                "p",
                                { staticStyle: { position: "relative" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        data.questionsItems.value === "group"
                                          ? "总分数"
                                          : "分 数"
                                      ) +
                                      " "
                                  ),
                                  _c("el-input", {
                                    ref: "examscore",
                                    refInFor: true,
                                    class: {
                                      "input-error":
                                        subjects.resScore > subjects.score,
                                    },
                                    staticStyle: { width: "70px" },
                                    attrs: {
                                      disabled:
                                        data.questionsItems.value === "group",
                                      size: "small",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.groupScore(subjects)
                                      },
                                    },
                                    model: {
                                      value: subjects.resScore,
                                      callback: function ($$v) {
                                        _vm.$set(subjects, "resScore", $$v)
                                      },
                                      expression: "subjects.resScore",
                                    },
                                  }),
                                  subjects.error
                                    ? _c(
                                        "span",
                                        { staticClass: "el-form-item__error" },
                                        [_vm._v(_vm._s(subjects.message))]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              data.questionsItems.value === "group"
                                ? _vm._l(
                                    subjects.children,
                                    function (childValue, childKey) {
                                      return _c(
                                        "div",
                                        {
                                          key:
                                            childKey +
                                            childValue.examQuestionsId,
                                          staticClass: "left_p",
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(
                                              "第" +
                                                _vm._s(childKey + 1) +
                                                "题: " +
                                                _vm._s(childValue.score) +
                                                "分"
                                            ),
                                          ]),
                                          _c(
                                            "p",
                                            {
                                              staticStyle: {
                                                position: "relative",
                                              },
                                            },
                                            [
                                              _vm._v(" 得 "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "example-score m-score",
                                                },
                                                [
                                                  _c("el-input", {
                                                    ref: "examscorechild",
                                                    refInFor: true,
                                                    class: {
                                                      "input-error":
                                                        childValue.resScore >
                                                        childValue.score,
                                                    },
                                                    staticStyle: {
                                                      width: "70px",
                                                    },
                                                    attrs: { size: "small" },
                                                    on: {
                                                      input: function ($event) {
                                                        return _vm.resetQuestionScore(
                                                          childValue,
                                                          subjects,
                                                          childKey
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        childValue.resScore,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          childValue,
                                                          "resScore",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "childValue.resScore",
                                                    },
                                                  }),
                                                  _vm._v(" 分 "),
                                                ],
                                                1
                                              ),
                                              childValue.error
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "el-form-item__error",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          childValue.message
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                          _c("el-divider"),
                                        ],
                                        1
                                      )
                                    }
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "right",
        fn: function () {
          return [
            _c("div", { staticClass: "item" }, [
              _c("p", { staticClass: "txt" }, [_vm._v("学员姓名")]),
              _c("p", { staticClass: "result" }, [
                _vm._v(_vm._s(_vm.examInfoData.examUserName)),
              ]),
            ]),
            _vm.type == 0
              ? _c("div", { staticClass: "item" }, [
                  _c("p", { staticClass: "txt" }, [_vm._v("剩余")]),
                  _c("p", { staticClass: "result" }, [
                    _vm._v(_vm._s(_vm.recordIds.remainNum) + "份试卷"),
                  ]),
                ])
              : _vm._e(),
            _c("div", { staticClass: "item" }, [
              _c("p", { staticClass: "txt" }, [_vm._v("试卷总分")]),
              _c("p", { staticClass: "result" }, [
                _vm._v(_vm._s(_vm.examInfoData.totalScore) + "分"),
              ]),
            ]),
            _c("dsf-setting-font-size"),
            _c(
              "div",
              { staticClass: "marking-post" },
              [
                _vm.recordIds.prevRecordId && _vm.type == 1
                  ? _c(
                      "el-button",
                      {
                        staticClass: "marking",
                        on: {
                          click: function ($event) {
                            return _vm.go("prev")
                          },
                        },
                      },
                      [_vm._v("上一人")]
                    )
                  : _vm._e(),
                _vm.recordIds.nextRecordId && _vm.type == 1
                  ? _c(
                      "el-button",
                      {
                        staticClass: "marking",
                        on: {
                          click: function ($event) {
                            return _vm.go("next")
                          },
                        },
                      },
                      [_vm._v("下一人")]
                    )
                  : _vm._e(),
                _c(
                  "el-button",
                  { staticClass: "marking main", on: { click: _vm.examPost } },
                  [_vm._v(_vm._s(_vm.type == 1 ? "修改" : "提交") + "阅卷")]
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }